import type { Product } from "@shared/types";
import type { SalesforceProduct } from "@shared/services";
import { axios } from ".";

export const SS_SKUS_BASE_URL = "/api/v1/products/ss-skus";
export const SS_BEANZ_PRODUCTS_URL = "/api/v1/products/beanz-products/salesforce";

export type SsProductActionType = "status" | "inventory" | "price";

export interface SsProductApprovalStatus {
  hasOpenAction: boolean;
  actionType?: SsProductActionType;
}

export interface CreateSsProductActionPayload {
  productId: string;
  actionType: SsProductActionType;
  statusValue?: string;
  inventoryValue?: number;
  priceValue?: number;
}

/** Fetches SS roaster products from Salesforce via GET /beanz-products/salesforce.
 *  Returns the same Product[] shape used by the Shopify import flow. */
export const getSsRoasterSalesforceProducts = async (): Promise<Product[]> => {
  const response = await axios.get<{ data: Product[] }>(SS_BEANZ_PRODUCTS_URL);
  return response.data.data;
};

export const createSsRoasterSku = async (
  payload: Partial<SalesforceProduct> | Partial<SalesforceProduct>[],
  accessToken: string
): Promise<void> => {
  const payloads = Array.isArray(payload) ? payload : [payload];
  await axios.post(SS_BEANZ_PRODUCTS_URL, payloads, {
    headers: { "x-access-token": accessToken },
  });
};

export const getSsProductApprovalStatus = async (productId: string, actionType: SsProductActionType): Promise<SsProductApprovalStatus> => {
  const url = `${SS_SKUS_BASE_URL}/${productId}/approval-status`;
  const response = await axios.get<{ data: SsProductApprovalStatus }>(url, {
    params: { actionType },
  });
  return response.data.data;
};

export const createSsProductAction = async (payload: CreateSsProductActionPayload): Promise<void> => {
  const url = `${SS_SKUS_BASE_URL}/${payload.productId}/actions`;
  await axios.post(url, payload);
};
